import React from 'react'
import { useSplitClient } from 'contrastBase/state'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'

const RemoteSetupSidebar = React.lazy(
  // @ts-expect-error
  () => import('platformAppConfig/SetupSidebar')
)

function getActiveComponent(isSplitTreatmentOn: (key: string) => boolean) {
  if (isSplitTreatmentOn('PROD-3062_app_config_ui')) {
    return RemoteSetupSidebar
  }
  // Add more as needed
  return null
}

export function Bridge() {
  const { isSplitTreatmentOn } = useSplitClient()
  const ActiveComponent = getActiveComponent(isSplitTreatmentOn)

  if (!ActiveComponent) {
    return null
  }

  return (
    <RemoteComponent>
      <ActiveComponent />
    </RemoteComponent>
  )
}

export const reactSidecar = createNgReactBridgeDirective(
  'reactSidecar',
  [],
  Bridge,
  []
)
